import { batch } from "react-redux";
import { requestAttributeData } from "state/attributes/actions";
import { requestAnalyticsData } from "state/analytics/actions";
import { requestPerfReturnData } from "state/perfReturns/actions";
import { requestRatingsData } from "state/ratings/actions";
import { requestTrackingErrorData } from "state/te/actions";
import { requestIssueCountData } from "state/issueCount/actions";
import { requestBetaData } from "state/betas/actions";
import { requestGridData } from "state/scenarioAnalysis/actions";
import { requestFactorAttributionData } from "state/factrib/actions";
import { requestTradeTrackingErrorData } from "state/tte/actions";
import { requestData as requestDurationToTargetData } from "state/durationToTarget/actions";
import { requestScan2Data } from "state/scan2/actions";
import { setSymbolicDate } from "state/selections/actions";

import {
  selectScenarioValue,
  selectModeValue,
} from "state/selections/selector";
import {
  fetchScenarioEntityIds,
  setScenarioEntityIds,
  fecthAsOfDate,
} from "state/scenario/actions";
import Mode from "state/selections/Mode";
import SelectionState from "state/selections/SelectionState";
import { throwError } from "@ls/error-module";
import moment from "moment";
import { requestBookAnalyticsData } from "state/bookAnalytics/actions";

export const SELECTION_DRAWER_TOGGLE = "app/SELECTION_DRAWER_TOGGLE";
export const toggleSelectionDrawer = (override) => ({
  type: SELECTION_DRAWER_TOGGLE,
  override,
});

export const SET_APP_TITLE = "app/DOCUMENT_TITLE_SET";
export const setAppTitle = (appTitle) => ({ type: SET_APP_TITLE, appTitle });

export const SET_LOAD_DATA_ON_LAUNCH = "app/LOAD_DATA_ON_LAUNCH";
export const setLoadDataOnLaunch = (value) => ({
  type: SET_LOAD_DATA_ON_LAUNCH,
  payload: value,
});

export const SET_MIN_INCEPTION_DATE = "app/SET_MIN_INCEPTION_DATE";
export const setMinInceptionDate = (minInceptionDate) => ({
  type: SET_MIN_INCEPTION_DATE,
  minInceptionDate,
});

export const SET_DISABLE_CUSTOM_GROUP_SORT = "app/SET_DISABLE_GROUPING_SORT";
export const setDisableCustomGroupSort = (disableCustomGroupSort) => ({
  type: SET_DISABLE_CUSTOM_GROUP_SORT,
  disableCustomGroupSort,
});

export const SET_DISABLE_INTERSPERSE = "app/SET_DISABLE_INTERSPERSE";
export const setDisableIntersperse = (disableIntersperse) => ({
  type: SET_DISABLE_INTERSPERSE,
  disableIntersperse,
});

export const SET_BANDED_ROWS = "app/SET_BANDED_ROWS";
export const setBandedRows = (bandedRows) => ({
  type: SET_BANDED_ROWS,
  bandedRows,
});

export const SET_GRID_VERTICAL_LINES = "app/SET_GRID_VERTICAL_LINES";
export const setGridVerticalLines = (gridVerticalLines) => ({
  type: SET_GRID_VERTICAL_LINES,
  gridVerticalLines,
});

export const SET_GRID_FONT_SIZE = "app/SET_GRID_FONT_SIZE";
export const setGridFontSize = (gridFontSize) => ({
  type: SET_GRID_FONT_SIZE,
  gridFontSize,
});

export const SET_LISTEN_SCENARIO_APP_TALK = "app/SET_LISTEN_SCENARIO_APP_TALK";
export const setListenScenarioAppTalk = (value) => ({
  type: SET_LISTEN_SCENARIO_APP_TALK,
  value,
});

export const SET_LISTEN_ENTITY_GROUP_APP_TALK =
  "app/SET_LISTEN_ENTITY_GROUP_APP_TALK";
export const setListenEntityGroupAppTalk = (value) => ({
  type: SET_LISTEN_ENTITY_GROUP_APP_TALK,
  value,
});

export const SET_HIDE_GRID_SIDE_BAR = "app/SET_HIDE_GRID_SIDE_BAR";
export const setHideGridSideBar = (value) => ({
  type: SET_HIDE_GRID_SIDE_BAR,
  value,
});

export const SET_GRID_ROW_HEIGHT = "app/SET_GRID_ROW_HEIGHT";
export const setGridRowHeight = (gridRowHeight) => ({
  type: SET_GRID_ROW_HEIGHT,
  gridRowHeight,
});

export const SET_GRID_HEADER_HEIGHT = "app/SET_GRID_HEADER_HEIGHT";
export const setGridHeaderHeight = (value) => ({
  type: SET_GRID_HEADER_HEIGHT,
  gridHeaderHeight: value,
});

export const SET_APP_DECIMAL = "app/SET_APP_DECIMAL";
export const setAppDecimal = (appDecimal) => ({
  type: SET_APP_DECIMAL,
  appDecimal,
});

export const startRequests = (in2Talk = false) => {
  return (dispatch, getState) => {
    batch(async () => {
      const state = getState();
      const scenarioValue = selectScenarioValue(SelectionState.COMMITTED)(
        state
      );
      const modeValue = selectModeValue(SelectionState.COMMITTED)(state);
      if (modeValue === Mode.SCENARIOS) {
        const entityIds = await dispatch(fetchScenarioEntityIds(scenarioValue));
        if (scenarioValue.length === 1 && in2Talk === true) {
          const scenarioDate = await dispatch(
            fecthAsOfDate(scenarioValue?.[0])
          );
          const asOfDate = !!scenarioDate
            ? moment(scenarioDate).format("YYYY-MM-DD")
            : null;
          dispatch(setSymbolicDate(asOfDate));
          // !!asOfDate && dispatch(setAsOfDate(asOfDate));
        }

        if (!entityIds?.length) {
          throwError(
            `Unable to find any entity ids for scenario ${scenarioValue}`
          );
          return;
        }
        dispatch(setScenarioEntityIds(entityIds));
      }
      dispatch(requestAttributeData());

      dispatch(requestAnalyticsData());
      dispatch(requestBookAnalyticsData());
      dispatch(requestBetaData());
      dispatch(requestGridData());
      dispatch(requestDurationToTargetData());
      dispatch(requestFactorAttributionData());
      dispatch(requestIssueCountData());
      dispatch(requestPerfReturnData());
      dispatch(requestRatingsData());
      dispatch(requestTrackingErrorData());
      dispatch(requestTradeTrackingErrorData());
      dispatch(requestScan2Data());
    });
  };
};
